import * as React from 'react';
import Button from '@mui/material/Button';
import { Box, ImageList, useMediaQuery } from '@mui/material';
import Grid from "@mui/material/Grid2"
import { useTrackedReservationCart } from "./CheckoutState"
import { send_authorized_request } from '../Constants/cognito'
import { LoadingBackdropIndeterminate } from './LoadingBackdrop';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PublishIcon from '@mui/icons-material/Publish';
import { AXIOS_API_INSTANCE } from '../Constants';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import CartItem from './CartItem';
import { useTheme } from '@emotion/react';
import CartEditDateModal from './CartEditDateModal';
import { moneyFormat } from '../Utils';
import CustomerSelection from './CustomerSelection';

export default function CartPage({ reserveStartDate, setReserveStartDate, reserveEndDate, setReserveEndDate, reservation_length, closeCartPage, open }) {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const [reservationCart, setReservationCart] = useTrackedReservationCart();
    const [customerData, setCustomerData] = React.useState({
        customer: {},
        createNewCustomer: false,
        editingCustomer: false,
        editedCustomer: {}
    })
    const [editingDate, setEditingDate] = React.useState(false)
    const [reservationCreatingStep, setReservationCreatingStep] = React.useState(0)
    const navigate = useNavigate();

    const editOrderTime = () => {
        setEditingDate(true)
    }
    const closeEditDateModal = () => {
        setEditingDate(false)
    }

    const saveReservation = (goToCheckout) => {
        const myRentalContract = {
            estimated_start_date: reserveStartDate,
            estimated_end_date: reserveEndDate,
            customer_id: customerData.customer.id,
            create_new_customer: customerData.createNewCustomer,
            edit_customer: customerData.editingCustomer,
            customer: customerData.editedCustomer,
            rental_items: reservationCart.cart.map((cartItem) => { return { id: cartItem.id, quantity: (cartItem.quantity || 1) } }),
            fees_data: reservationCart.fees_data,
            location_id: reservationCart.cart[0].location.id
        }
        setReservationCreatingStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.put(`/rentalcontracts/reserve`, myRentalContract).then((rentalContract) => {
            console.log(rentalContract);
            setReservationCreatingStep(0)
            setReservationCart({ cart: [], fees_data: {} })
            setCustomerData({
                customer: {},
                createNewCustomer: false,
                editingCustomer: false,
                editedCustomer: {}
            })
            enqueueSnackbar('Successfully created reservation', { variant: 'success' })
            if (goToCheckout) {
                navigate(`/Contracts/${rentalContract.data.data.id}`)
            } else {
                closeCartPage(true)
            }
        }).catch((error) => {
            setReservationCreatingStep(0)
            enqueueSnackbar(`Failed to create reservation <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
        })
        )
    }

    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={reservationCreatingStep > 0}
                text={"Creating Reservation"}
            />
            <Box sx={{ margin: 'auto', display: open ? 'block' : 'none' }}>
                <CustomerSelection
                    updateFunction={(update) => { setCustomerData({ ...update }) }}
                    customerData={customerData}
                />
                <Box>
                    <Grid container spacing={4}>
                        <Grid size={6}>
                            <Grid spacing={1} container alignItems={"center"}>
                                <Grid size="auto">
                                    <h3>Date & Time</h3>
                                </Grid>
                                <Grid size="grow">
                                    <Button onClick={(e) => { editOrderTime() }}>
                                        <ModeEditIcon /> <Box sx={{ pl: 1 }}>Edit</Box>
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction={"column"}>
                                    <Grid item>
                                        <span>From: {reserveStartDate.format('ddd, MMM D h:mm A')}</span>
                                    </Grid>
                                    <Grid item>
                                        <span>To: {reserveEndDate.format('ddd, MMM D h:mm A')}</span>
                                    </Grid>
                                    <Grid item>
                                        <span><b>{Math.floor((reserveEndDate - reserveStartDate) / 1000 / 60 / 60 / 24) % 7} days, {Math.floor((reserveEndDate - reserveStartDate) / 1000 / 60 / 60) % 24} hrs</b></span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={6}>
                            <h3>Payment</h3>
                            <Grid container spacing={3}>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            <span>Contract Total:</span>
                                        </Grid>
                                        <Grid item>
                                            <span>Deposit Total:</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            <span>${moneyFormat(reservationCart.cart.reduce((accumulator, item) => accumulator + item.calculated_posttax_total, 0))}</span>
                                        </Grid>
                                        <Grid item>
                                            <span>${moneyFormat(reservationCart.cart.reduce((accumulator, item) => accumulator + item.calculated_deposit, 0))}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <h3>Items ({reservationCart.cart.length})</h3>
                <ImageList variant="standard" cols={isMdDown ? 2 : 3} gap={8}>
                    {reservationCart.cart.map((item) =>
                    (
                        <CartItem
                            item={item}
                            reservation_length={reservation_length}
                            reserveStartDate={reserveStartDate}
                            reserveEndDate={reserveEndDate}
                        />
                    )
                    )}

                </ImageList>
                <Grid container columnSpacing={6} sx={{ padding: "0px 30px 10px 30px" }}>
                    <Grid size="auto">
                        <Button onClick={() => closeCartPage(false)}><ArrowBackIcon /><Box sx={{ pl: 1 }}>Back</Box></Button>
                    </Grid>
                    <Grid size="auto">
                        <Button variant="contained" disabled={reservationCart.cart.length === 0 || (customerData.customer.id === undefined && !customerData.createNewCustomer)} onClick={() => saveReservation(false)}><PublishIcon /><Box sx={{ pl: 1 }}>Save Reservation</Box></Button>
                    </Grid>
                    <Grid size="auto">
                        <Button variant="contained" disabled={reservationCart.cart.length === 0 || (customerData.customer.id === undefined && !customerData.createNewCustomer)} onClick={() => saveReservation(true)}><ShoppingCartCheckoutIcon /><Box sx={{ pl: 1 }}>Go To Checkout</Box></Button>
                    </Grid>
                </Grid>
                {editingDate &&
                    <CartEditDateModal
                        reserveStartDate={reserveStartDate}
                        setReserveStartDate={setReserveStartDate}
                        reserveEndDate={reserveEndDate}
                        setReserveEndDate={setReserveEndDate}
                        open={editingDate}
                        closeModal={closeEditDateModal}
                    />
                }
            </Box>
        </React.Fragment >)
    );
}